<template>
    <div class="list">
        <div class="no-survey" v-if="recurrentSurveys.length === 0 && eventSurveys.length === 0">
            <div class="no-survey__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
                    <path d="M445 167.364c4.143 0 7.5-3.357 7.5-7.5V107.5c0-12.406-10.094-22.5-22.5-22.5h-7.5V65c0-12.406-10.094-22.5-22.5-22.5h-7.5v-20C392.5 10.094 382.406 0 370 0H82C69.593 0 59.5 10.094 59.5 22.5v41.365c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5V22.5c0-4.136 3.364-7.5 7.5-7.5h288c4.136 0 7.5 3.364 7.5 7.5v382c0 4.136-3.364 7.5-7.5 7.5H82c-4.136 0-7.5-3.364-7.5-7.5V95.865c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5V404.5c0 12.406 10.093 22.5 22.5 22.5h7.5v20c0 12.406 10.093 22.5 22.5 22.5h7.5v20c0 12.406 10.093 22.5 22.5 22.5h288c12.406 0 22.5-10.094 22.5-22.5V191.679c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5V489.5c0 4.136-3.364 7.5-7.5 7.5H142c-4.136 0-7.5-3.364-7.5-7.5v-20h185.367c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5H112c-4.135 0-7.5-3.364-7.5-7.5v-20H370c12.406 0 22.5-10.094 22.5-22.5v-347h7.5c4.136 0 7.5 3.364 7.5 7.5v382c0 4.136-3.364 7.5-7.5 7.5h-48.319c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5H400c12.406 0 22.5-10.094 22.5-22.5V100h7.5c4.136 0 7.5 3.364 7.5 7.5v52.364c0 4.143 3.357 7.5 7.5 7.5z"/>
                    <path d="M110 124v52c0 6.341 5.159 11.5 11.5 11.5h52c6.341 0 11.5-5.159 11.5-11.5v-38.676l15.37-13.12a7.499 7.499 0 00.834-10.573 7.5 7.5 0 00-10.574-.835l-6.924 5.91c-1.919-3.684-5.773-6.206-10.207-6.206h-52c-6.34 0-11.499 5.159-11.499 11.5zm15 3.5h45v2.907l-14.882 12.704-7.106-7.698a7.5 7.5 0 00-11.022 10.174l12 13a7.5 7.5 0 0010.381.617l10.63-9.075V172.5h-45v-45zM334.5 124.5h-120c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h120c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM334.5 156.5h-120c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h120c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM110 273c0 6.341 5.159 11.5 11.5 11.5h52c6.341 0 11.5-5.159 11.5-11.5v-52c0-6.341-5.159-11.5-11.5-11.5h-52c-6.341 0-11.5 5.159-11.5 11.5zm15-48.5h45v45h-45zM334.5 221.5h-120c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h120c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM334.5 253.5h-120c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h120c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM110 370c0 6.341 5.159 11.5 11.5 11.5h52c6.341 0 11.5-5.159 11.5-11.5v-52c0-6.341-5.159-11.5-11.5-11.5h-52c-6.341 0-11.5 5.159-11.5 11.5zm15-48.5h45v45h-45zM334.5 318.5h-120c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h120c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM334.5 350.5h-120c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h120c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM296.5 35.5h-138c-13.785 0-25 11.215-25 25s11.215 25 25 25h138c13.785 0 25-11.215 25-25s-11.215-25-25-25zm0 35h-138c-5.514 0-10-4.486-10-10s4.486-10 10-10h138c5.514 0 10 4.486 10 10s-4.486 10-10 10z"/>
                </svg>
            </div>
            <div class="no-survey__title">
                Aucun questionnaire n'est associé à ce compte
            </div>
            <div class="no-survey__text">
                Pour le moment, aucun questionnaire n'est associé au compte {{ displayName }}, vous pouvez recharger la liste des
                questionnaires en cliquant sur le bouton ci-dessous
            </div>
            <button class="no-survey__sync" v-tap v-on:click="refreshSurveyList">
                Synchroniser
            </button>
        </div>
        <div class="unsynced-surveys" v-if="unsyncedResponses.length > 0">
            <div class="unsynced-surveys__icon">
                <svg width="150px" height="150px" viewBox="0 0 150 150" version="1.1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                        <rect id="path-1" x="78" y="222" width="1981" height="302" rx="8"></rect>
                        <filter x="-0.4%" y="-1.5%" width="100.9%" height="106.0%" filterUnits="objectBoundingBox"
                                id="filter-2">
                            <feOffset dx="0" dy="5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1"
                                            result="shadowBlurOuter1"></feGaussianBlur>
                            <feColorMatrix
                                    values="0 0 0 0 0.771399457   0 0 0 0 0.771399457   0 0 0 0 0.771399457  0 0 0 0.5 0"
                                    type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                        </filter>
                    </defs>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Home" transform="translate(-164.000000, -288.000000)">
                            <g id="Rectangle" fill-rule="nonzero">
                                <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                                <use fill="#FFFFFF" xlink:href="#path-1"></use>
                            </g>
                            <g id="Group" transform="translate(164.000000, 288.000000)">
                                <circle id="Oval" fill="#FF0000" opacity="0.0793108259" cx="75" cy="75" r="75"></circle>
                                <g id="error" transform="translate(36.000000, 37.000000)" fill="#FF5B5D"
                                   fill-rule="nonzero">
                                    <path d="M76.06695,59.91225 L43.08225,2.78115 C42.105,1.0884 40.35465,0.07785 38.4,0.07785 C36.44535,0.07785 34.695,1.0884 33.71775,2.78115 L0.73305,59.91225 C-0.24435,61.605 -0.24435,63.62625 0.73305,65.31885 C1.7103,67.0116 3.46065,68.02215 5.4153,68.02215 L71.3847,68.02215 C73.33935,68.02215 75.0897,67.0116 76.06695,65.31885 C77.04435,63.62625 77.04435,61.605 76.06695,59.91225 Z M72.16515,63.06615 C72.0681,63.23445 71.83725,63.51675 71.38485,63.51675 L5.4153,63.51675 C4.9626,63.51675 4.7319,63.2346 4.635,63.06615 C4.53795,62.898 4.40865,62.55705 4.635,62.1651 L37.61955,5.03385 C37.8459,4.6419 38.2056,4.58325 38.39985,4.58325 C38.59425,4.58325 38.95395,4.64175 39.18015,5.03385 L72.165,62.1651 C72.3915,62.55705 72.2622,62.898 72.16515,63.06615 Z"
                                          id="Shape"></path>
                                    <rect id="Rectangle" x="36.14805" y="20.56425" width="4.50555"
                                          height="24.02955"></rect>
                                    <circle id="Oval" cx="38.40075" cy="52.1031" r="3.00375"></circle>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <div class="unsynced-surveys__text">
                <div class="unsynced-surveys__text__title">
                    Vous avez <b>{{ unsyncedResponses.length }} questionnaires</b> non synchronisés avec le serveur
                </div>
                <div class="unsynced-surveys__text__text">
                    Les questionnaires sont enregistrés sur votre tablette et sont régulièrement synchronisés avec le
                    serveur, assurez-vous d’être connecté à internet pour synchroniser les questionnaires.
                </div>
            </div>
            <div v-if="surveyIsSyncing">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <button class="unsynced-surveys__button" v-tap v-on:click="syncSurveys" v-if="!surveyIsSyncing">
                Synchroniser
            </button>
        </div>
        <section class="section" v-if="recurrentSurveys.length > 0">
            <div class="section-title">Questionnaire annuel</div>
            <div class="goals" v-if="getRemainingGoals()">
                <div class="goals__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="165" height="165" viewBox="0 0 165 165">
                        <g fill="#2AAACE" fill-rule="evenodd">
                            <circle cx="82.5" cy="82.5" r="82.5" opacity=".079"/>
                            <path fill-rule="nonzero" d="M116.781 44H56.435A6.442 6.442 0 0050 50.435v3.268a23.485 23.485 0 005.128 14.62c2.751 3.438 6.663 6.131 11.017 7.582l2.274.758a21.368 21.368 0 0011.754 9.19v3.335a2.148 2.148 0 01-2.145 2.145 6.442 6.442 0 00-6.435 6.435v2.145h-2.145c-1.185 0-2.145.96-2.145 2.145v10.868h-2.145a2.145 2.145 0 100 4.29h42.9a2.145 2.145 0 100-4.29h-2.145v-10.868c0-1.185-.96-2.145-2.145-2.145h-2.145v-2.145a6.442 6.442 0 00-6.435-6.435 2.148 2.148 0 01-2.145-2.145v-3.335a21.367 21.367 0 0011.746-9.176l2.397-.763.027-.009a23.355 23.355 0 0010.875-7.582 23.485 23.485 0 005.128-14.62v-3.268A6.442 6.442 0 00116.781 44zM58.478 65.643a19.181 19.181 0 01-4.188-11.94v-3.268c0-1.183.962-2.145 2.145-2.145h6.803l2.183 19.647c.128 1.149.35 2.271.656 3.36-3-1.26-5.66-3.232-7.599-5.654zm13.115 47.283v-8.723h30.03v8.723h-30.03zm18.824-30.8a2.145 2.145 0 00-1.664 2.09v4.972a6.442 6.442 0 006.435 6.435c1.183 0 2.145.962 2.145 2.145v2.145h-21.45v-2.145c0-1.183.962-2.145 2.145-2.145a6.442 6.442 0 006.435-6.435v-4.971c0-1-.69-1.867-1.664-2.09-7.05-1.623-12.32-7.516-13.114-14.664l-2.13-19.173h38.107l-2.13 19.173c-.795 7.148-6.065 13.041-13.115 14.663zm28.509-28.423c0 4.324-1.488 8.564-4.188 11.94a19.065 19.065 0 01-7.618 5.72c.315-1.11.544-2.254.675-3.426l2.183-19.647h6.803c1.183 0 2.145.962 2.145 2.145v3.268z"/>
                            <path fill-rule="nonzero" d="M95.49 58.688l-4.821-.684-2.147-4.246a2.145 2.145 0 00-3.828 0l-2.147 4.246-4.82.684a2.145 2.145 0 00-1.178 3.677l3.458 3.29-.814 4.633a2.146 2.146 0 003.091 2.28l4.324-2.22 4.323 2.22a2.144 2.144 0 003.092-2.28l-.814-4.632 3.458-3.291a2.144 2.144 0 00-1.178-3.677zm-6.07 4.652a2.144 2.144 0 00-.635 1.926l.266 1.515-1.464-.752a2.145 2.145 0 00-1.959 0l-1.464.752.267-1.515a2.147 2.147 0 00-.634-1.926l-1.08-1.027 1.541-.219a2.144 2.144 0 001.613-1.156l.737-1.458.737 1.458a2.145 2.145 0 001.613 1.156l1.541.218-1.08 1.028z"/>
                        </g>
                    </svg>
                </div>
                <div class="goals__text">
                    <div class="goals__text__title">
                        <b>Encore {{ getRemainingGoals() }} questionnaires</b> pour compléter l’objectif <small>({{ this.goals.answer_number }}/{{ this.goals.objective_number }})</small></div>
                    <div class="goals__text__text">
                        Remplissez vos objectifs mensuels en complétant la barre de progression, les objectifs sont définis uniquement sur le questionnaire annuel.
                        <div class="goals__text__progress">
                            <div class="goals__text__progress__bar" v-bind:style="{ width: goals.percent+ '%' }"></div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="survey" v-for="survey in recurrentSurveys" :key="survey.id">
                <svg width="31px" height="26px" viewBox="0 0 61 46" version="1.1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                        <rect id="path-1" x="0" y="0" width="1981" height="196" rx="8"></rect>
                        <filter x="-0.4%" y="-2.3%" width="100.9%" height="109.2%" filterUnits="objectBoundingBox"
                                id="filter-2">
                            <feOffset dx="0" dy="5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1"
                                            result="shadowBlurOuter1"></feGaussianBlur>
                            <feColorMatrix
                                    values="0 0 0 0 0.771399457   0 0 0 0 0.771399457   0 0 0 0 0.771399457  0 0 0 0.5 0"
                                    type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                        </filter>
                    </defs>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Home" transform="translate(-133.000000, -788.000000)" fill-rule="nonzero">
                            <g id="Rectangle-2" transform="translate(78.000000, 709.000000)">
                                <g id="Rectangle">
                                    <use fill="black" fill-opacity="1" filter="url(#filter-2)"
                                         xlink:href="#path-1"></use>
                                    <use fill="#FFFFFF" xlink:href="#path-1"></use>
                                </g>
                            </g>
                            <g id="list" transform="translate(133.000000, 788.000000)" fill="#000000">
                                <path d="M57.124,44.893 L16.92,44.893 C15.263,44.893 13.92,43.55 13.92,41.893 C13.92,40.236 15.263,38.893 16.92,38.893 L57.123,38.893 C58.78,38.893 60.123,40.236 60.123,41.893 C60.123,43.55 58.781,44.893 57.124,44.893 Z"
                                      id="Path"></path>
                                <path d="M57.124,26.062 L16.92,26.062 C15.263,26.062 13.92,24.719 13.92,23.062 C13.92,21.405 15.263,20.062 16.92,20.062 L57.123,20.062 C58.78,20.062 60.1230006,21.405 60.1230006,23.062 C60.124,24.719 58.781,26.062 57.124,26.062 Z"
                                      id="Path"></path>
                                <path d="M57.124,7.231 L16.92,7.231 C15.263,7.231 13.92,5.888 13.92,4.231 C13.92,2.574 15.263,1.231 16.92,1.231 L57.123,1.231 C58.78,1.231 60.123,2.574 60.123,4.231 C60.123,5.888 58.781,7.231 57.124,7.231 Z"
                                      id="Path"></path>
                                <circle id="Oval" cx="4.029" cy="4.463" r="4.029"></circle>
                                <circle id="Oval" cx="4.029" cy="23.062" r="4.029"></circle>
                                <circle id="Oval" cx="4.029" cy="41.661" r="4.029"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
                <div class="survey__texts">
                    <div class="survey__texts__name">
                        {{ survey.name }}
                    </div>
                    <div class="survey__texts__description">
                        {{ survey.description }}
                    </div>
                </div>
                <a class="survey__button" href="#" v-on:click="openSurvey(survey.id)">Commencer un questionnaire</a>
                <Survey :survey="survey" v-if="surveyIsOpen(survey.id)"/>
            </div>
        </section>
        <section class="section" v-if="eventSurveys.length > 0">
            <div class="section-title">
                Questionnaires événementiels
            </div>
            <div class="survey" v-for="survey in eventSurveys" :key="survey.id">
                <svg width="31px" height="26px" viewBox="0 0 61 46" version="1.1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                        <rect id="path-1" x="0" y="0" width="1981" height="196" rx="8"></rect>
                        <filter x="-0.4%" y="-2.3%" width="100.9%" height="109.2%" filterUnits="objectBoundingBox"
                                id="filter-2">
                            <feOffset dx="0" dy="5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1"
                                            result="shadowBlurOuter1"></feGaussianBlur>
                            <feColorMatrix
                                    values="0 0 0 0 0.771399457   0 0 0 0 0.771399457   0 0 0 0 0.771399457  0 0 0 0.5 0"
                                    type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                        </filter>
                    </defs>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Home" transform="translate(-133.000000, -788.000000)" fill-rule="nonzero">
                            <g id="Rectangle-2" transform="translate(78.000000, 709.000000)">
                                <g id="Rectangle">
                                    <use fill="black" fill-opacity="1" filter="url(#filter-2)"
                                         xlink:href="#path-1"></use>
                                    <use fill="#FFFFFF" xlink:href="#path-1"></use>
                                </g>
                            </g>
                            <g id="list" transform="translate(133.000000, 788.000000)" fill="#000000">
                                <path d="M57.124,44.893 L16.92,44.893 C15.263,44.893 13.92,43.55 13.92,41.893 C13.92,40.236 15.263,38.893 16.92,38.893 L57.123,38.893 C58.78,38.893 60.123,40.236 60.123,41.893 C60.123,43.55 58.781,44.893 57.124,44.893 Z"
                                      id="Path"></path>
                                <path d="M57.124,26.062 L16.92,26.062 C15.263,26.062 13.92,24.719 13.92,23.062 C13.92,21.405 15.263,20.062 16.92,20.062 L57.123,20.062 C58.78,20.062 60.1230006,21.405 60.1230006,23.062 C60.124,24.719 58.781,26.062 57.124,26.062 Z"
                                      id="Path"></path>
                                <path d="M57.124,7.231 L16.92,7.231 C15.263,7.231 13.92,5.888 13.92,4.231 C13.92,2.574 15.263,1.231 16.92,1.231 L57.123,1.231 C58.78,1.231 60.123,2.574 60.123,4.231 C60.123,5.888 58.781,7.231 57.124,7.231 Z"
                                      id="Path"></path>
                                <circle id="Oval" cx="4.029" cy="4.463" r="4.029"></circle>
                                <circle id="Oval" cx="4.029" cy="23.062" r="4.029"></circle>
                                <circle id="Oval" cx="4.029" cy="41.661" r="4.029"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
                <div class="survey__texts">
                    <div class="survey__texts__name">
                        {{ survey.name }}
                    </div>
                    <div class="survey__texts__description">
                        {{ survey.description }}
                    </div>
                </div>
                <a class="survey__button" href="#" v-on:click="openSurvey(survey.id)">Commencer un questionnaire</a>
                <Survey :survey="survey" v-if="surveyIsOpen(survey.id)"/>
            </div>
        </section>

    </div>
</template>

<script>
    import Survey from './Survey.vue'
    import {mapState} from 'vuex'
    import {EventBus} from './../../event-bus.js';


    export default {
        name: 'SurveyList',
        components: {
            Survey,
        },
        data() {
            return {
                surveyOpen: false,
                surveyIsSyncing: false
            };
        },
        computed: mapState({
            displayName: state => state.authentication.displayName,
            unsyncedResponses: state => state.surveys.unsyncedResponses,
            recurrentSurveys: state => state.surveys.recurrentSurveys,
            eventSurveys: state => state.surveys.eventSurveys,
            goals: state => state.surveys.goals
        }),
        methods: {
            getRemainingGoals(){
                if(this.goals.answer_number < this.goals.objective_number){
                    return this.goals.objective_number - this.goals.answer_number;
                } else {
                    return false;
                }
            },
            surveyIsOpen(id) {
                if (this.surveyOpen === id) {
                    return true;
                }

                return false;
            },
            openSurvey(id) {
                this.surveyOpen = id;
            },
            closeSurvey() {
                this.surveyOpen = false;
            },
            syncSurveys() {
                this.surveyIsSyncing = true;
                this.$store.dispatch('surveys/syncSurveys');

                EventBus.$on('surveySyncSuccess', () => {
                    this.surveyIsSyncing = false;
                });

                EventBus.$on('surveySyncError', () => {
                    this.surveyIsSyncing = false;
                });
            },
            refreshSurveyList() {
                this.$store.dispatch('surveys/getSurveysList');
            }
        },
        created() {
            this.refreshSurveyList();
        },
        mounted() {
            EventBus.$on('requestSurveySync', () => {
                this.refreshSurveyList();
            });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .no-survey {
        padding-top: 20vh;

        &__icon {
            svg {
                width: 120px;
                height: 120px;
            }

            margin-bottom: 20px;
        }

        &__title {
            font-size: 26px;
            font-weight: 500;
        }

        &__text {
            max-width: 500px;
            margin: auto;
            opacity: .7;
            margin-top: 15px;
        }

        &__sync{
            margin-top: 30px;
            appearance: none;
            display: inline-block;
            border: none;
            background-color: #2AAACE;
            color: white;
            font-family: inherit;
            font-size: 15px;
            padding: 13px 35px;
            border-radius: 6px;
            font-weight: 600;
            outline: none;
        }
    }

    .section {
        margin-bottom: 40px;
    }

    .lds-ring {
        display: inline-block;
        width: 50px;
        height: 50px;
        margin-left: 40px;
        margin-right: 20px;
        padding: 10px;
    }

    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 50px;
        height: 50px;
        margin: 8px;
        border: 4px solid black;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #FF5B5D transparent transparent transparent;
    }

    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }

    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }

    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .list {
        padding: 30px 30px;
    }

    .section-title {
        text-align: left;
        font-size: 23px;
        font-weight: 500;
        margin-bottom: 30px;
    }

    .unsynced-surveys,
    .goals{
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(178, 178, 178, 0.50);
        border-radius: 4px;
        margin-bottom: 30px;
        padding: 30px;
        text-align: left;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        &__text {
            &__title {
                font-size: 22px;
                font-weight: 500;
            }

            &__text {
                margin-top: 10px;
                opacity: .8;
            }

            &__progress{
                background-color: #E9E9E9;
                width: 100%;
                border-radius: 20px;
                overflow: hidden;
                margin-top: 20px;

                &__bar{
                    width: 0%;
                    background-color: #2AAACE;
                    height: 5px;
                }
            }
        }

        &__icon {
            margin-right: 30px;

            svg {
                width: 65px;
                height: 65px;
            }
        }

        &__button {
            margin-left: 20px;
            appearance: none;
            display: inline-block;
            padding: 14px 30px;
            background: #FF5B5D;
            border-radius: 9px;
            font-weight: 600;
            font-family: inherit;
            color: white;
            border: 0;
            font-size: 16px;
            outline: none;
        }
    }

    .goals{
        &__icon{
            svg{
                width: 75px;
                height: 75px;
            }
        }
    }

    .survey {
        border-radius: 3px;
        padding: 20px 35px;
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(178, 178, 178, 0.50);
        border-radius: 8px;
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &__texts {
            text-align: left;
            flex: 1 1 auto;
            margin-left: 25px;

            &__name {
                font-weight: 500;
                font-size: 20px;
            }

            &__description {
                opacity: 0.63;
                font-size: 15px;
                color: #333333;
            }
        }

        &__button {
            background: #72BD32;
            border-radius: 8px;
            padding: 15px 25px;
            color: white;
            text-decoration: none;
            font-weight: 600;
        }
    }
</style>
